import { fg } from '@atlassian/jira-feature-gating';

const jiv22472HasSummaryToMIAQFeatureGate = {
	get(): boolean {
		return fg('jiv-22472-has-summary-to-miaq');
	},
};

export default jiv22472HasSummaryToMIAQFeatureGate;
